import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommunityRedirectService } from '@common/services/community-redirect.service';

@Injectable({ providedIn: 'root' })
export class RedirectGuard  {
    constructor(
        private redirectService: CommunityRedirectService,
        private router: Router,
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
    ): Observable<UrlTree> | Observable<boolean> {
        let community = this.redirectService.getRedirectData();
        if (!community) {
            return of(true);
        } else {
            return of(this.router.createUrlTree([community]));
        }
    }
}
